<template>
  <div class="jin-index">
    <JinPc />
    <JinM />
  </div>
</template>

<script>
import JinPc from './page/pc'
import JinM from './page/mobile'

export default {
  components: {
    JinPc,
    JinM
  },
  data() {
    return {}
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  boforeDestory() {
    document.removeEventListener('scroll', this.handleScroll) // 移除页面滚动事件
  },
  methods: {
    // pc端添加页面滚动时元素的动画
    handleScroll() {
      const applyFadeInUpElements = document.querySelectorAll('.apply-fadeInUp-el')
      const clients =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      applyFadeInUpElements.forEach((el, i) => {
        const divTop = el.getBoundingClientRect().top
        if (divTop <= clients) {
          el.classList.add('show-scrolled-animation')
          el.classList.remove('apply-fadeInUp-el')
        }
      })
    }
  }
}
</script>
